// src/services/api/FooterServ.js

import { get, post, put, destroy } from './base';

export const FooterServ = {

  // GET ALL FOOTERS
  index: () =>
    get('/footers'),

  // CREATE FOOTER
  create: (payload) =>
    post('/footers', payload),

  // UPDATE FOOTER
  update: (id, payload) =>
    put(`/footers/${id}`, payload),

  // DELETE FOOTER
  remove: (id) =>
    destroy(`/footers/${id}`),
};